import {twJoin} from 'tailwind-merge'
import {useRef} from 'react'

import {useContainerQuery} from '../../hooks'
import {ResponsiveMedia} from '../ResponsiveMedia'

import type {ResponsiveMediaType} from '../ResponsiveMedia'

export interface ChapterOpenerProps {
  media: ResponsiveMediaType
  count?: number
  title?: string
}

export const ChapterOpener = ({
  media,
  count,
  title,
}: ChapterOpenerProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isDesktop = useContainerQuery({containerRef, width: 704})

  return (
    <div
      ref={containerRef}
      className={'@container/block'}
      data-testid={'chapterOpener'}
    >
      <div className={'relative aspect-[2/3] @[704px]:aspect-[3/2]'}>
        <div className={'pullout-rounded-lg absolute z-20 size-full bg-scrim-primary/[.4] mix-blend-multiply'}></div>
        <ResponsiveMedia
          media={media}
          currentScreenSize={isDesktop ? 'desktop' : 'mobile'}
          classNames={{
            image: 'pullout-rounded-lg absolute size-full object-cover object-center',
            video: 'pullout-rounded-lg absolute z-30 size-full',
          }}
        />
        <div
          className={twJoin([
            'absolute z-30 flex flex-col justify-end items-start size-full gap-spacing-16 px-spacing-20 py-spacing-56',
            '@[704px]:gap-spacing-24 @[704px]:p-block-large',
            'text-glyph-inversed-secondary',
          ])}
        >
          {count ? (
            <h2 className={'border-b-1 border-b-glyph-inversed-secondary pb-spacing-16 text-h2-xs @[704px]:pb-spacing-20 @[704px]:text-h2'}>
              {`${count}`.padStart(2, '0').slice(0, 12)}
            </h2>
          ) : null}
          {title ? (
            <h2 className={'line-clamp-2 text-h1-xs @[704px]:text-h1'}>
              {title.slice(0, 32)}
            </h2>
          ) : null}
        </div>
      </div>
    </div>
  )

}
